import advertiserService from '../../services/advertiser';

const types = {
  GET_ALL_ADVERTISERS: 'advertiserService/getAllAdvertisers',
};

const state = {
  allAdvertisers: [],
};

const getters = {
  getAllAdvertisers: s => s.allAdvertisers,
};

const actions = {
  actionGetAllAdvertisers({ commit }) {

    advertiserService
    .getAllAdvertisers()
    .then((res) => { 

      const {
        _data,
      } = res;
      
      commit(types.GET_ALL_ADVERTISERS, _data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },
};

// mutations
const mutations = {
  [types.GET_ALL_ADVERTISERS](s, d) {
    s.allAdvertisers = d;
  },
};

/*
  因為我們把 vuex 所有職權都寫在同一隻檔案，
  所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/advertiser.js